// extracted by mini-css-extract-plugin
export var content = "_qt-1";
export var divider = "_qt-0";